import React, { useState } from "react";
import { FaEye } from "react-icons/fa6";
import { FaEyeSlash } from "react-icons/fa6";
import { CiLinkedin, CiYoutube, CiInstagram, CiCircleAlert } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import api from '../common/api.js';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import Login from "./Login.js";
import LoginQuotesPanel from "./LoginQuotesPanel.js";
import SocialMedia from "./SocialMedia.js";
import useTenantAssets from "../common/useTenantLogo.js";
import "../App.css";


const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { getLogo } = useTenantAssets();
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("");
  const [orgName, setOrgName] = useState("");
  const [phone, setPhone] = useState();
  const [error, setError] = useState({});

  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  }


  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);



    const data = userType === "individual" ?
      {
        "name": username,
        "password": password,
        "email": email,
        "userType": userType,
        "phone": phone
      } :
      {
        "organisation": orgName,
        "name": username,
        "password": password,
        "email": email,
        "phone": phone
      }

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!username.trim()) {
      newErrors.username = "Name is Required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (data.password.length < 8 || !/[A-Z]/.test(data.password) || !/[0-9]/.test(data.password) || !/[!@#$%^&*(),.?":{}|<>]/.test(data.password)) {
      newErrors.password = "Password requires at least 8 characters, 1 uppercase, 1 number and 1 special character";
    }

    if (!phone) {
      newErrors.phone = "Phone number is required";
    } else if (!isValidPhoneNumber(phone)) {
      newErrors.phone = "Please enter a valid phone number";
    }


    if (userType !== "individual" && !data.organisation) {
      newErrors.organisation = "Organisation name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      console.error("New error:", newErrors);
      return;
    }
    setError({});

    api.post("/register", data)
      .then((response) => {
        setLoading(false);
        navigate('/Login', { state: { "register": true } });
      })
      .catch((err) => {
        if (err.status === 400 && err.response && err.response.data && err.response.data.error)
          setErrorMsg(err.response.data.error)
        else {
          setErrorMsg(err.message);
        }
        setLoading(false);
      });

  }



  const changeOrgName = (value) => {
    setOrgName(value);
    if (error.organisation) {
      setError(prev => ({ ...prev, organisation: "" }));
    }
  }

  const changeName = (value) => {
    setUsername(value);
    if (error.username) {
      setError(prev => ({ ...prev, username: "" }));
    }
  };

  const changeEmail = (value) => {
    setEmail(value);
    if (error.email) {
      setError(prev => ({ ...prev, email: "" }));
    }
  };

  const changePasswd = (value) => {
    setPassword(value);
    if (error.password) {
      setError(prev => ({ ...prev, password: "" }));
    }
  };

  const changePhone = (value) => {
    setPhone(value);
    if (error.phone) {
      setError(prev => ({ ...prev, phone: "" }));
    }
  };

  const handleUserTypeSelect = (currentUserType) => {
    setUserType(currentUserType);
    setUsername("");
    setEmail("");
    setPassword("");
    setOrgName("");
    setError({});
  };

  return (
    <div className="login-main">
      <LoginQuotesPanel />
      <div className="login-left">
        <div className="login-left-container">
          <div className="login-logo">
            <img src={getLogo("login")} alt="" />
          </div>
          <div className="login-center">

            {!userType ? (
              <div className="register-type-select" style={{ position: 'relative', zIndex: 1000 }}>
                <h2 className="mb-5">Who are you registering for ?</h2>

                <DropdownButton className="custom-dropdown-btn" id="basic-dropdown-button" title="Select an option">
                  <Dropdown.Item className="custom-dropdown-item" onClick={() => handleUserTypeSelect("individual")}>
                    Individual
                  </Dropdown.Item>
                  <Dropdown.Item className="custom-dropdown-item" onClick={() => handleUserTypeSelect("organisation")}>
                    Organisation
                  </Dropdown.Item>
                </DropdownButton>
              </div>) : (<>
                <h2>
                  {
                    userType === "individual"
                      ? <>Create your <span className="highlight">Individual</span> Account</>
                      : <>Create your <span className="highlight">Organisation</span> Account</>
                  }
                </h2>
                <form onSubmit={submit} noValidate>

                  {errorMsg && (
                    <div className="d-flex justify-content-center mt-3">
                      <div className="alert alert-danger  d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm text-center">
                        <CiCircleAlert size={20} />
                        <span className="fw-semibold">{errorMsg}</span>
                      </div>
                    </div>
                  )}

                  {userType === "organisation" && (
                    <>
                      <div className="error-box"><input
                        type="text"
                        placeholder="Organisation Name"
                        onChange={(e) => { changeOrgName(e.target.value) }}
                      />
                        {error.organisation && <span className="error-text">{error.organisation}</span>}</div>
                    </>
                  )}
                  <div className="error-box"><input type="text" placeholder="Enter Name" onChange={(e) => { changeName(e.target.value) }} />
                    {error.username && <span className="error-text">{error.username}</span>}</div>
                  <>
                    <div className="error-box">
                      <div className="custom-phone-input" >
                        <PhoneInput
                          name='customer_phone'
                          international
                          value={phone}
                          onChange={(value) => changePhone(value)}
                          placeholder="Enter mobile number"
                          limitMaxLength={true}
                        />


                      </div>
                      {error.phone && <span className="error-text">{error.phone}</span>}
                    </div>

                  </>
                  <div className="error-box"><input type="email" placeholder="Enter Email address" onChange={e => changeEmail(e.target.value)} />
                    {error.email && <span className="error-text">{error.email}</span>}</div>
                  <div className="pass-input-div">
                    <div className="error-box"><input type={showPassword ? "text" : "password"} placeholder="Enter Password" onChange={e => changePasswd(e.target.value)} />
                      {error.password && <span className="error-text">{error.password}</span>}
                      {showPassword ? <FaEyeSlash onClick={() => { setShowPassword(!showPassword) }} /> : <FaEye onClick={() => { setShowPassword(!showPassword) }} />}
                    </div></div>



                  <div className="btn-group">
                    <div className="register-center-buttons">
                      <button type="submit">Submit</button>
                      <div className="go-back-button">
                        <button
                          type="button"
                          onClick={() => setUserType("")}
                        >
                          ←
                        </button>
                      </div>
                    </div>
                  </div>



                </form>

                {/* Already have an account Section */}
                <div className="new-user-section mt-4">
                  Already have an account?{' '}
                  <span onClick={handleLogin} className="create-account-link">
                    Log in
                  </span>
                </div>
              </>)
            }

            {/* Already have an account Section for Select User Type */}

          </div>

          {!userType && (
            <div className="new-user-section"
              style={{ marginTop: "10rem" }}
            >
              Already have an account?{' '}
              <span onClick={handleLogin} className="create-account-link">
                Log in
              </span>
            </div>
          )}



          <SocialMedia />
        </div>
      </div>



    </div>

  );
};

export default Register;